import React, { useState, useEffect, useRef } from 'react';
import MobileBottomSheet from './MobileBottomSheet';

export default function CreateMenu({ isOpen, onClose, position, onCreatePlaylist, onCreateFolder, folders }) {
  const [showForm, setShowForm] = useState(null); // 'playlist' or 'folder'
  const [name, setName] = useState('');
  const [description, setDescription] = useState('');
  const [folderId, setFolderId] = useState(null);
  const menuRef = useRef(null);
  const [isMobile, setIsMobile] = useState(window.innerWidth < 768);

  useEffect(() => {
    const handleResize = () => setIsMobile(window.innerWidth < 768);
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  useEffect(() => {
    if (isMobile) return;
    const handleClickOutside = (event) => {
      if (menuRef.current && !menuRef.current.contains(event.target)) {
        handleClose();
      }
    };

    if (isOpen) {
      document.addEventListener('mousedown', handleClickOutside);
    }

    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [isOpen]);

  const handleClose = () => {
    setShowForm(null);
    setName('');
    setDescription('');
    setFolderId(null);
    onClose();
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    
    if (!name.trim()) return;
    
    if (showForm === 'playlist') {
      onCreatePlaylist({ name, description, folder_id: folderId });
    } else if (showForm === 'folder') {
      onCreateFolder({ name });
    }
    
    handleClose();
  };

  if (!isOpen) return null;

  const content = !showForm ? (
    // Menu de sélection
    <div>
      <button
        onClick={() => setShowForm('playlist')}
        className="w-full px-2 py-3 hover:bg-white/10 text-left transition-colors flex items-center gap-3"
      >
        <svg className="w-7 h-7" fill="white" viewBox="0 0 24 24">
          <path d="M15 6H3v2h12V6zm0 4H3v2h12v-2zM3 16h8v-2H3v2zM17 6v8.18c-.31-.11-.65-.18-1-.18-1.66 0-3 1.34-3 3s1.34 3 3 3 3-1.34 3-3V8h3V6h-5z"/>
        </svg>
        <div>
          <div className="font-semibold text-lg">Créer une playlist</div>
          <div className="text-sm text-white/70">Une collection de pistes</div>
        </div>
      </button>
    </div>
  ) : (
    // Formulaire de création
    <form onSubmit={handleSubmit} className="px-1 py-3">
      <h3 className="text-lg font-bold mb-3">
        {showForm === 'playlist' ? 'Nouvelle playlist' : 'Nouveau dossier'}
      </h3>
      
      <div className="space-y-3">
        <input
          type="text"
          value={name}
          onChange={(e) => setName(e.target.value)}
          placeholder="Nom"
          className="w-full px-3 py-2 bg-white/10 border border-white/20 rounded text-base focus:border-white/40 focus:outline-none"
          autoFocus
        />
        
        {showForm === 'playlist' && (
          <>
            <textarea
              value={description}
              onChange={(e) => setDescription(e.target.value)}
              placeholder="Description (optionnel)"
              className="w-full px-3 py-2 bg-white/10 border border-white/20 rounded text-base focus:border-white/40 focus:outline-none resize-none"
              rows="2"
            />
            
            {folders && folders.length > 0 && (
              <select
                value={folderId || ''}
                onChange={(e) => setFolderId(e.target.value || null)}
                className="w-full px-3 py-2 bg-white/10 border border-white/20 rounded text-base focus:border-white/40 focus:outline-none"
              >
                <option value="">Aucun dossier</option>
                {folders.map(folder => (
                  <option key={folder.id} value={folder.id}>{folder.name}</option>
                ))}
              </select>
            )}
          </>
        )}
      </div>
      
      <div className="flex gap-2 mt-4">
        <button
          type="button"
          onClick={() => setShowForm(null)}
          className="flex-1 px-3 py-2 text-base border border-white/20 rounded hover:bg-white/10 transition-colors"
        >
          Retour
        </button>
        <button
          type="submit"
          disabled={!name.trim()}
          className="flex-1 px-3 py-2 text-base bg-white text-black rounded font-semibold hover:scale-105 transition-transform disabled:opacity-50 disabled:cursor-not-allowed"
        >
          Créer
        </button>
      </div>
    </form>
  );

  if (isMobile) {
    return (
      <MobileBottomSheet isOpen={isOpen} onClose={handleClose}>
        {content}
      </MobileBottomSheet>
    );
  }

  return (
    <div
      ref={menuRef}
      className="absolute bg-zinc-900 rounded-lg shadow-2xl border border-white/10 py-2 min-w-[280px] z-50"
      style={{
        top: position.y,
        left: position.x,
      }}
    >
      {content}
    </div>
  );
}
